export default "__VITE_ASSET__QTSRRzDh__"